import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { AccountService } from '@treasury/domain/channel/services';
import { TmBaseComponent } from '@treasury/presentation';
import { mailIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-loader';
import { css, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../../components/jhd-tooltip';

export const tagName = 'messages-header-item';
@customElement(tagName)
export class MessagesHeaderItem extends TmBaseComponent {
    @InjectProperty()
    declare private accountService: AccountService;

    @state()
    private unreadMessageCount = 0;

    @state()
    private loading = false;

    protected async firstUpdated() {
        this.loading = true;
        const { unreadMessageCount } = await this.accountService.getUserSettings();
        this.unreadMessageCount = unreadMessageCount;
        this.loading = false;
    }

    protected render() {
        if (this.loading) {
            return html`<tm-loader reversed></tm-loader>`;
        }
        return html`<div class="relative">
            <tm-icon color="var(--jh-color-gray-0)" .icon=${mailIcon}></tm-icon
            >${this.renderMessageCount()}
        </div>`;
    }

    private renderMessageCount() {
        if (!this.unreadMessageCount) {
            return nothing;
        }
        return html`<div
            class="absolute -top-2 -end-2 inline-flex items-center justify-center min-w-4 h-4 px-1 rounded-full text-xs text-white whitespace-nowrap bg-[--jh-color-red-500]"
        >
            ${this.unreadMessageCount}
        </div>`;
    }

    public static get styles() {
        return [
            css`
                .icon-wrapper {
                    position: relative;
                }
                path {
                    fill: var(--jh-color-gray-0);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: MessagesHeaderItem;
    }
}
